import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { setDriveTrain } from 'Store/AssetManagement/DriveTrain/DriveTrainAction';
import { GET_DRIVE_TRAIN } from 'Store/AssetManagement/DriveTrain/DriveTrainType';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getDriveTrains(request: any): any {
    let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/vehicle/drivetrain/${request.subTypeId}`,
        payload : null
    }

    try {
        yield put(globalLoaderText("Fetching Values..."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response?.length > 0) {
            const defaultOption = {
                text: "Select Drive Train",
                value: null
            };
            response.unshift(defaultOption);
        }
        yield put(setDriveTrain(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setDriveTrain([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetDriveTrain() {
    yield takeEvery(GET_DRIVE_TRAIN, getDriveTrains)
}

export default function* combinedSaga() {
    yield all([
        watchGetDriveTrain()
    ])
}
